var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorLockDblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.835,
    cy: 24.835,
    r: 20.835,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 45.8346C13.4936 45.8346 4.1665 36.5076 4.1665 25.0013C4.1665 13.4951 13.4936 4.16797 24.9998 4.16797C36.5061 4.16797 45.8332 13.4951 45.8332 25.0013C45.8332 36.5076 36.5061 45.8346 24.9998 45.8346ZM22.9165 26.6513V33.3346H27.0832V26.6513C28.1798 26.1727 29.0783 25.331 29.6274 24.2679C30.1765 23.2048 30.3428 21.985 30.0983 20.8137C29.8538 19.6424 29.2135 18.5909 28.285 17.8362C27.3565 17.0815 26.1964 16.6695 24.9998 16.6695C23.8033 16.6695 22.6432 17.0815 21.7147 17.8362C20.7862 18.5909 20.1458 19.6424 19.9014 20.8137C19.6569 21.985 19.8232 23.2048 20.3723 24.2679C20.9214 25.331 21.8198 26.1727 22.9165 26.6513Z",
    fill: "#213B98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorLockDblue);
export default __webpack_public_path__ + "static/media/door-lock-dblue.7ac892f850cf0eafdabd19bcbe3e0c11.svg";
export { ForwardRef as ReactComponent };